"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partners = void 0;
const types_1 = require("./types");
exports.partners = {
    [types_1.Partner.AVIZIO]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil aux entreprises',
    }),
    [types_1.Partner.BFM]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Assistance au développement commercial auprès d’une cible de clientèle employée par l’état',
    }),
    [types_1.Partner.BRIGAD]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    }),
    [types_1.Partner.CARIZY]: () => ({
        activityCategory: 'BNC',
        activityType: '7120A',
        job: 'Inspection automobile',
    }),
    [types_1.Partner.COMET]: ({ COMET }) => {
        switch (COMET) {
            case 'Développeur':
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: 'Développeur',
                };
            case 'Data scientist':
                return {
                    activityCategory: 'BNC',
                    activityType: '6202A',
                    job: 'Data scientist',
                };
            default: {
                // eslint-disable-next-line no-console
                console.warn(`Unknown job for COMET: ${COMET}`);
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: 'Développeur',
                };
            }
        }
    },
    [types_1.Partner.CONVOICAR]: () => ({
        activityCategory: 'BIC',
        activityType: '4941B',
        job: 'Convoyage de véhicules par la route',
    }),
    [types_1.Partner.COURSIER_JOB]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de courses et de repas à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.CREADS]: () => ({
        activityCategory: 'BNC',
        activityType: '7410Z',
        job: 'Graphiste',
    }),
    [types_1.Partner.CREME_DE_LA_CREME]: ({ CREME }) => {
        switch (CREME) {
            case 'Développeur':
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: 'Développeur',
                };
            case 'Designer':
                return {
                    activityCategory: 'BNC',
                    activityType: '7410Z',
                    job: 'Designer',
                };
            case 'Consultant marketing':
                return {
                    activityCategory: 'BNC',
                    activityType: '7022Z',
                    job: 'Consultant marketing',
                };
            case 'Chef de projet digital':
                return {
                    activityCategory: 'BNC',
                    activityType: '7022Z',
                    job: 'Chef de projet digital',
                };
            default: {
                // eslint-disable-next-line no-console
                console.warn(`Unknown job for CREME: ${CREME}`);
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: "Développeur (Vérifier avec l'utilisateur)",
                };
            }
        }
    },
    [types_1.Partner.CUBYN]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Distribution de colis pour les commerçants',
    }),
    [types_1.Partner.CYCLOFIX]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: "Livraison d'outils de réparation de cycles à vélo",
        jobTag: 'BIKER',
    }),
    [types_1.Partner.DELIVEROO]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.DREAM_CATCHER]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Consultant en business developpement',
    }),
    [types_1.Partner.EXPLAIN]: () => ({
        activityCategory: 'BNC',
        activityType: '7320Z',
        job: 'Etudes de marché et sondages en porte à porte (sans vente)',
    }),
    [types_1.Partner.EXTRACADABRA]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    }),
    [types_1.Partner.FRICHTI]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.FRIZBIZ]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '',
        job: 'Petits travaux ou services',
    }),
    [types_1.Partner.GLOVO]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.HEETCH]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '4932Z',
        job: 'Location de voitures avec chauffeur',
    }),
    [types_1.Partner.IBBU]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil pour les affaires et autres conseils de gestion',
    }),
    [types_1.Partner.INSPECTVO]: () => ({
        activityCategory: 'BNC',
        activityType: '7120A',
        job: 'Inspection automobile',
    }),
    // DEPRECATED replaced by CARIZY
    [types_1.Partner.IRON_HACK]: () => ({
        activityCategory: 'BNC',
        activityType: '6201Z',
        job: 'Développeur',
    }),
    [types_1.Partner.KAPTEN]: () => ({
        activityCategory: 'BIC',
        activityType: '4932Z',
        craftsmanship: true,
        job: 'Location de voitures avec chauffeur',
    }),
    [types_1.Partner.KERMESS]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil pour les affaires et autres conseils de gestion',
    }),
    [types_1.Partner.LA_TAMBOUILLE]: () => ({
        activityCategory: 'BIC',
        activityType: '5621Z',
        craftsmanship: true,
        job: 'Fabrication de plats à emporter',
    }),
    [types_1.Partner.LE_CLUB_DES_EXTRAS]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    }),
    [types_1.Partner.LE_REACTEUR]: () => ({
        activityCategory: 'BNC',
        activityType: '6201Z',
        job: 'Développeur',
    }),
    [types_1.Partner.LE_PERMIS_LIBRE]: () => ({
        activityCategory: 'BNC',
        activityType: '8553Z',
        job: 'Enseignant de la conduite',
    }),
    [types_1.Partner.LES_COURSIERS_FRANCAIS]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de courses et de repas à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.LES_TONTONS_LIVREURS]: () => ({
        activityCategory: 'BIC',
        activityType: '4941C',
        job: 'Location de camions avec chauffeur',
    }),
    [types_1.Partner.LIME]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Enlèvement et livraison de marchandises non réglementé à vélo',
    }),
    [types_1.Partner.MALT]: ({ MALT }) => {
        switch (MALT) {
            case 'Développeur':
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: 'Développeur',
                };
            case 'Photographe':
                return {
                    activityCategory: 'OTHER_JOB',
                    activityType: '7420Z',
                    job: 'Photographe',
                };
            case 'Réalisateur':
                return {
                    activityCategory: 'BNC',
                    activityType: '5911B',
                    job: 'Réalisateur',
                };
            case 'Designer':
                return {
                    activityCategory: 'BNC',
                    activityType: '7410Z',
                    job: 'Designer',
                };
            case 'Consultant marketing':
                return {
                    activityCategory: 'BNC',
                    activityType: '7022Z',
                    job: 'Consultant marketing',
                };
            case 'Community manager':
                return {
                    activityCategory: 'BNC',
                    activityType: '7021Z',
                    job: 'Community manager',
                };
            case 'Chef de projet digital':
                return {
                    activityCategory: 'BNC',
                    activityType: '7022Z',
                    job: 'Chef de projet digital',
                };
            default: {
                // eslint-disable-next-line no-console
                console.warn(`Unknown job for MALT: ${MALT}`);
                return {
                    activityCategory: 'BNC',
                    activityType: '6201Z',
                    job: "Développeur (Vérifier avec l'utilisateur)",
                };
            }
        }
    },
    [types_1.Partner.MANNERS]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    }),
    [types_1.Partner.MERCI_JACK]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '',
        job: 'Petits travaux ou services',
    }),
    [types_1.Partner.MON_SPECIALISTE_AUTO]: () => ({
        activityCategory: 'BNC',
        activityType: '7120A',
        job: 'Inspection automobile',
    }),
    [types_1.Partner.MY_BIZ_DEV]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Consultant en business developpement',
    }),
    [types_1.Partner.NANNY_PLEASE]: () => ({
        activityCategory: 'BNC',
        activityType: '8891A',
        job: "Garde d'enfants",
    }),
    [types_1.Partner.NEED_HELP]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '',
        job: 'Petits travaux ou services',
    }),
    [types_1.Partner.NESTOR]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.OCUS]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '7420Z',
        job: 'Photographe',
    }),
    [types_1.Partner.ORNIKAR]: () => ({
        activityCategory: 'BNC',
        activityType: '8553Z',
        job: 'Enseignant de la conduite',
    }),
    [types_1.Partner.PARKOPOLY]: () => ({
        activityCategory: 'BIC',
        activityType: '4941B',
        job: 'Convoyage de véhicules par la route',
    }),
    [types_1.Partner.PARKOURS]: () => ({
        activityCategory: 'BNC',
        activityType: '8559B',
        job: 'Accompagnement scolaire dans les établissements',
    }),
    [types_1.Partner.SIDE]: () => ({
        activityCategory: 'BNC',
        activityType: '7022Z',
        job: 'Conseil stratégique en entreprise',
    }),
    [types_1.Partner.STOOTIE]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '',
        job: 'Petits travaux ou services',
    }),
    [types_1.Partner.STUART]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de courses et de repas à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.TASK_RABBIT]: () => ({
        activityCategory: 'OTHER_JOB',
        activityType: '',
        job: 'Petits travaux ou services',
    }),
    [types_1.Partner.THE_HAIRCUT]: () => ({
        activityCategory: 'BIC',
        activityType: '9602A',
        job: 'Coiffure à domicile',
    }),
    [types_1.Partner.UBER_EATS]: () => ({
        activityCategory: 'BIC',
        activityType: '5320Z',
        job: 'Livraison de repas et de courses à domicile à vélo',
        jobTag: 'BIKER',
    }),
    [types_1.Partner.WE_ARE_SMART]: () => ({
        activityCategory: 'BIC',
        activityType: '4799A',
        job: "Vente & location d'équipement téléphonique",
    }),
};
